const translations = {
  ko: {
    // 탭
    tab_home: '홈',
    tab_category: '카테고리',
    tab_map: '지도',
    tab_memories: '추억',
    tab_settings: '설정',

    // 홈
    home_loading: '불러오는 중...',
    home_no_records: '아직 기록이 없어요.',
    home_add_first: '+ 버튼을 눌러 첫 기록을 추가해보세요!',
    home_no_search: '에 대한 결과가 없어요.',
    home_search_placeholder: '제목, 카테고리, 메모, 위치 검색',
    home_all: '전체',
    home_sort_newest: '최신순',
    home_sort_oldest: '오래된순',
    home_records_count: '개의 기록',
    home_cancel: '취소',

    // 기록 추가/수정
    record_add: '기록 추가',
    record_edit: '기록 수정',
    record_category: '카테고리',
    record_title: '제목',
    record_title_placeholder: '기록 제목을 입력하세요',
    record_period: '기간',
    record_start_date: '시작일',
    record_end_date: '종료일',
    record_same_day: '당일',
    record_ongoing: '현재 진행중',
    record_location: '위치',
    record_location_placeholder: '장소 검색 (예: 강남역, 서울대학교)',
    record_search: '검색',
    record_photos: '사진',
    record_memo: '메모',
    record_memo_placeholder: '메모를 입력하세요 (선택)',
    record_profiles: '표시할 프로필',
    record_save: '저장',
    record_saving: '저장 중...',
    record_delete: '삭제',
    record_deleting: '삭제 중...',
    record_share: '공유하기',
    record_sharing: '공유 준비 중...',
    record_custom_input: '직접 입력',
    record_custom_placeholder: '카테고리 이름 직접 입력',
    record_emoji_select: '이모지 선택',
    record_main_photo: '대표',

    // 카테고리 관리
    category_manage: '카테고리 관리',

    // 프로필 관리
    profile_manage: '프로필 관리',
    profile_my: '내 프로필',
    profile_in_use: '사용 중',
    profile_select: '선택',
    profile_add: '프로필 추가',
    profile_new: '새 프로필 추가',
    profile_edit: '수정',
    profile_name_placeholder: '프로필 이름 (예: 나, 아이, 가족)',
    profile_cancel: '취소',
    profile_save: '저장',
    profile_add_btn: '추가',
    profile_hint1: '프로필을 선택하면 해당 프로필의 기록만 홈에서 표시됩니다.',
    profile_hint2: '기록 추가 시 다른 프로필과 공유할 수 있습니다.',
    profile_transfer: '프로필 승계',

    // 설정
    settings_title: '설정',
    settings_backup: '백업 & 복원',
    settings_backup_btn: '데이터 백업',
    settings_backup_loading: '백업 중...',
    settings_restore_btn: '데이터 복원',
    settings_restore_loading: '복원 중...',
    settings_backup_hint: '백업 파일은 기기에 저장되며, 복원 시 기존 데이터와 병합됩니다.',
    settings_transfer: '프로필 승계',
    settings_transfer_btn: '프로필 승계 받기',
    settings_transfer_loading: '승계 처리 중...',
    settings_transfer_hint: '다른 사람이 보낸 승계 파일을 불러와 프로필과 기록을 받을 수 있습니다.',
    settings_transfer_hint2: '승계 파일 만들기는 프로필 관리에서 공유(↑) 버튼을 눌러주세요.',
    settings_display: '화면',
    settings_dark_mode: '다크모드',
    settings_notification: '추억 알림',
    settings_notification_hint: '추억 알림을 켜면 과거 오늘 날짜의 기록을 알려드립니다.',
    settings_account: '계정',
    settings_change_pw: '비밀번호 변경',
    settings_changing_pw: '변경 중...',
    settings_logout: '로그아웃',
    settings_app_info: '앱 정보',
    settings_language: '언어',

    // 추억
    memories_title: '추억',
    memories_empty: '오늘의 추억이 없어요.',
    memories_anniversary: '오늘의 기념일',
    memories_year_memories: '추억',
    memories_year_records: '기록',

    // 로그인
    login_title: '인생로그',
    login_subtitle: '나의 인생을 기록하다',
    login_email: '이메일',
    login_password: '비밀번호',
    login_btn: '로그인',
    login_signup: '회원가입',
    login_kakao: '카카오로 로그인',
    login_or: '또는',
    login_forgot: '비밀번호를 잊으셨나요?',
    login_find_pw: '비밀번호 찾기',
    login_no_account: '계정이 없으신가요?',
    login_has_account: '이미 계정이 있으신가요?',
    login_back_to_login: '로그인으로 돌아가기',
    login_reset_email: '비밀번호 재설정 이메일 보내기',
    login_processing: '처리 중...',

    // 홈 화면 추가
    settings_add_home: '홈 화면에 추가',
    install_already: '이미 앱으로 설치되어 있습니다.',
    install_browser_hint: '브라우저 메뉴(⋮)에서 "홈 화면에 추가"를 선택해주세요.',
    install_ios_title: '홈 화면에 추가하기',
    install_ios_step1: '하단의 공유 버튼(□↑)을 탭하세요',
    install_ios_step2: '"홈 화면에 추가"를 선택하세요',
    install_ios_step3: '"추가"를 탭하면 완료!',
    install_ios_close: '확인',

    // 스플래시
    splash_loading: '나의 이야기를 불러오는 중',

    // 공통
    current: '현재',
    year: '년',
    month: '월',
    count_unit: '개',
    confirm_delete: '정말 삭제하시겠습니까?',
    confirm_logout: '로그아웃 하시겠습니까?',
  },

  en: {
    tab_home: 'Home',
    tab_category: 'Categories',
    tab_map: 'Map',
    tab_memories: 'Memories',
    tab_settings: 'Settings',

    home_loading: 'Loading...',
    home_no_records: 'No records yet.',
    home_add_first: 'Tap + to add your first record!',
    home_no_search: ' — no results found.',
    home_search_placeholder: 'Search title, category, memo, location',
    home_all: 'All',
    home_sort_newest: 'Newest',
    home_sort_oldest: 'Oldest',
    home_records_count: ' records',
    home_cancel: 'Cancel',

    record_add: 'Add Record',
    record_edit: 'Edit Record',
    record_category: 'Category',
    record_title: 'Title',
    record_title_placeholder: 'Enter record title',
    record_period: 'Period',
    record_start_date: 'Start',
    record_end_date: 'End',
    record_same_day: 'Same day',
    record_ongoing: 'Ongoing',
    record_location: 'Location',
    record_location_placeholder: 'Search place (e.g., Gangnam Station)',
    record_search: 'Search',
    record_photos: 'Photos',
    record_memo: 'Memo',
    record_memo_placeholder: 'Enter memo (optional)',
    record_profiles: 'Show in profiles',
    record_save: 'Save',
    record_saving: 'Saving...',
    record_delete: 'Delete',
    record_deleting: 'Deleting...',
    record_share: 'Share',
    record_sharing: 'Preparing...',
    record_custom_input: 'Custom',
    record_custom_placeholder: 'Enter category name',
    record_emoji_select: 'Select emoji',
    record_main_photo: 'Main',

    category_manage: 'Manage Categories',

    profile_manage: 'Manage Profiles',
    profile_my: 'My Profiles',
    profile_in_use: 'Active',
    profile_select: 'Select',
    profile_add: 'Add Profile',
    profile_new: 'New Profile',
    profile_edit: 'Edit',
    profile_name_placeholder: 'Profile name (e.g., Me, Child, Family)',
    profile_cancel: 'Cancel',
    profile_save: 'Save',
    profile_add_btn: 'Add',
    profile_hint1: 'Selecting a profile shows only its records on Home.',
    profile_hint2: 'You can share records with other profiles when adding.',
    profile_transfer: 'Transfer Profile',

    settings_title: 'Settings',
    settings_backup: 'Backup & Restore',
    settings_backup_btn: 'Backup Data',
    settings_backup_loading: 'Backing up...',
    settings_restore_btn: 'Restore Data',
    settings_restore_loading: 'Restoring...',
    settings_backup_hint: 'Backup files are saved locally and merged with existing data on restore.',
    settings_transfer: 'Profile Transfer',
    settings_transfer_btn: 'Receive Profile',
    settings_transfer_loading: 'Processing...',
    settings_transfer_hint: 'Import a transfer file to receive a profile and its records.',
    settings_transfer_hint2: 'To create a transfer file, tap the share (↑) button in Profile Management.',
    settings_display: 'Display',
    settings_dark_mode: 'Dark Mode',
    settings_notification: 'Memory Alerts',
    settings_notification_hint: 'Get notified about records from the same date in past years.',
    settings_account: 'Account',
    settings_change_pw: 'Change Password',
    settings_changing_pw: 'Changing...',
    settings_logout: 'Sign Out',
    settings_app_info: 'App Info',
    settings_language: 'Language',

    memories_title: 'Memories',
    memories_empty: 'No memories for today.',
    memories_anniversary: "Today's Milestones",
    memories_year_memories: 'Memories',
    memories_year_records: 'records',

    login_title: 'lifelog',
    login_subtitle: 'Record your life story',
    login_email: 'Email',
    login_password: 'Password',
    login_btn: 'Sign In',
    login_signup: 'Sign Up',
    login_kakao: 'Sign in with Kakao',
    login_or: 'or',
    login_forgot: 'Forgot password?',
    login_find_pw: 'Reset Password',
    login_no_account: "Don't have an account?",
    login_has_account: 'Already have an account?',
    login_back_to_login: 'Back to Sign In',
    login_reset_email: 'Send Reset Email',
    login_processing: 'Processing...',

    settings_add_home: 'Add to Home Screen',
    install_already: 'Already installed as an app.',
    install_browser_hint: 'Select "Add to Home Screen" from the browser menu (⋮).',
    install_ios_title: 'Add to Home Screen',
    install_ios_step1: 'Tap the Share button (□↑) at the bottom',
    install_ios_step2: 'Select "Add to Home Screen"',
    install_ios_step3: 'Tap "Add" and you\'re done!',
    install_ios_close: 'OK',

    splash_loading: 'Loading your stories',

    current: 'Current',
    year: '',
    month: '',
    count_unit: '',
    confirm_delete: 'Are you sure you want to delete?',
    confirm_logout: 'Sign out?',
  },
};

const LANG_KEY = 'lifelog_lang';

export function getLang() {
  return localStorage.getItem(LANG_KEY) || 'ko';
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang);
}

export function t(key) {
  const lang = getLang();
  return translations[lang]?.[key] || translations.ko[key] || key;
}
